import * as React from 'react'

type Props = {
  className?: string
  svgClassName?: string
}

export default function InnerLogo({ className = '', svgClassName = '' }: Props) {
  return (
    <div className={`relative inline-flex pt-[3px] ${className}`}>
      <svg width="135" height="38" className={svgClassName}>
        <use xlinkHref="#logo" />
      </svg>
    </div>
  )
}
